ALLOWED_CONTROLLER = 'gateways'
ALLOWED_ACTIONS = ['index']

ready = ->
  return unless continueIfAllowed(ALLOWED_CONTROLLER, ALLOWED_ACTIONS)
  table = $('#gateways').DataTable({
    iDisplayLength: 50,
    order: [ [ 0, "asc" ] ],
    aoColumnDefs: [ { 'bSortable': false, 'aTargets': [ 9,10 ] }, {
      "targets": [ 10 ],
      "visible": false
    } ],
    dom: '<"fg-toolbar ui-toolbar ui-widget-header ui-helper-clearfix ui-corner-bl ui-corner-br"f<"decommissioned_checkbox">rltip>'
  })

  $("div.decommissioned_checkbox").on "change", (e) ->
    table.draw()

  $.fn.dataTable.ext.search.push( ( settings, data, dataIndex ) ->
    use_decommissioned = $('#decommissioned_checkbox_id').prop('checked')
    if use_decommissioned
      return true
    else
      return data[10] == 'false'
  )
  style_form_for($("div.decommissioned_checkbox"))

$(document).ready(ready)

style_form_for = (decommissioned_checkbox) ->
  $("#gateways_filter").css("width", "25%")
  $("#gateways_processing").css("left", "65%")
  decommissioned_checkbox.html("<input type=\"checkbox\" id=\"decommissioned_checkbox_id\" name=\"add_decommissioned\">" +
    "<label for=\"decommissioned_checkbox_id\">show&nbsp;decommissioned</label></input>")
